import { createContext, useContext } from 'react';
import { Source } from '../types';

type DataQueryContextState = {
  allowedSourceTypes: string[];
  isError: boolean;
  isLoading: boolean;
  refetchSyncs: () => void;
  syncs: Source[];
};

export const DataQueryContext = createContext<DataQueryContextState | undefined>(undefined);

export const useDataQueryContext = () => {
  const context = useContext<DataQueryContextState | undefined>(DataQueryContext);
  if (context === undefined) {
    throw new Error('useDataQueryContext must be used within a DataQueryContextProvider');
  }
  return context;
};
